/*
 * The Private License
 *
 * Copyright (c) 2025 Mahon Media LLC.
 */

/**
 * Get base URL.
 * @returns string The url of the backend server.
 */
export function getBackendBaseUrl() {
  // const baseUrl = `${process.env.REACT_APP_API_HOST}` ?  `${process.env.REACT_APP_API_HOST}` : `https://hub.northviewhg.com`;
  const baseUrl = `https://hub.northviewhg.com`;
  return baseUrl;
}


export function getOperaPopulateApiUrl() {
  // const baseUrl = `${process.env.REACT_OPERA_API_HOST}` ?  `${process.env.REACT_OPERA_API_HOST}` : `https://hub.northviewhg.com`;
  const baseUrl = `https://hub.northviewhg.com`;
  return baseUrl;
}
